export const environment = {
	shopname: 'Ocarina',
	shopdescription: 'Ocarina',
	production: false,
	analytics: undefined,
	theme: 'tools',
	collectionlayout: 'leftsidebar',
	collectionpagesize: 16,
	productlayout: 'leftsidebar',
	themecolor: '#1B6194',
	logo: 'ocarina.png',
	shopcover: 'ocarina.png',
	b2b: false,
	maxprice: 200,
	showpricefilter: false,
	storecode: 'ocarinadev',
	showvat: true,
	dafaultlang: 'it',
	leftmenu: true,
	needsinvoice: false,
	showcompany: true,
	showshipmentservices: false,
	defaultcountry: 'IT',
	onlydefaultcountry: false,
	completenewsletter: true,
	shopURL: 'https://ocarina.elbuild.com',
	baseURL: 'https://ocarina.elbuild.com',
	topbartext: 'Welcome to Ocarina',
	copyright: 'Ocarina è un marchio Sindbad S.r.l. - Via Giano della Bella, 23 50124 Firenze - P.IVA: IT06117640489',
	analyticsdebug: true,
	ing4url: undefined,
	showdocuments: false,
	baseProductURL: '/shop/product/',
	showsendmailbtn: false,
	loginredirecturl: '/signin',
	showSecurePaymentText: false,
	stripeLayout: 'default',
	showMobilePrefix: false,
	forgotpasswordredirecturl: '/forgot-password',
	registerRedirectUrl: '/signup',
	invertedaddresssteps: false,
	usaaddressstyle: false,
	apiprefix: '/ws/',
	runisolated: false,
	externalapi: '/ws/',
	customsections: ['ocarinaplayers'],
	wishlistURL: 'https://ocarina.elbuild.com/wishlist',
	caneditbillingaddress: true

};
